// taskTypeMeta.js
// Shared metadata for task_type rendering across Tasks, TaskDetail,
// TaskActionModal, RemindersList, and calendar task chips.

export const ENGAGEMENT_ACCENT = '#16A34A';

export const TASK_TYPE_META = {
  inbound_call: {
    label: 'Inbound Call',
    icon: 'fa-sharp fa-regular fa-phone',
    accent: ENGAGEMENT_ACCENT
  },
  consultation: {
    label: 'Consultation',
    icon: 'fa-sharp fa-regular fa-calendar-clock',
    accent: ENGAGEMENT_ACCENT
  },
  materials_check: {
    label: 'Materials Check',
    icon: 'fa-sharp fa-regular fa-box-check',
    accent: '#2563EB'
  },
  reorder: {
    label: 'Reorder',
    icon: 'fa-sharp fa-regular fa-cart-plus',
    accent: '#2563EB'
  }
};

const DEFAULT_META = {
  label: 'Reminder',
  icon: 'fa-sharp fa-regular fa-bell',
  accent: '#8B5CF6'
};

export const getTaskTypeMeta = (taskType) => TASK_TYPE_META[taskType] || DEFAULT_META;

// Task types whose Complete action REQUIRES a resolution_type
// (server returns 400 without one — the outcome drives GHL re-engagement automation)
export const ENGAGEMENT_TYPES = ['inbound_call', 'consultation'];

export const isEngagementType = (taskType) => ENGAGEMENT_TYPES.includes(taskType);

export const OUTCOME_OPTIONS = [
  {
    value: 'contact_attempted',
    label: 'Attempted — no answer / left message',
    hint: 'Keeps the customer’s re-engagement follow-ups going.'
  },
  {
    value: 'handled_no_action',
    label: 'Handled — no further action needed',
    hint: 'Stops the "we missed you" sequence.'
  }
];
